export function ajaxRequest(requestUrl, {
    type = 'get', data, query, params = {},
}) {
    const queryString = new URLSearchParams(query || {}).toString();
    const url = queryString ? `${requestUrl}?${queryString}` : requestUrl;

    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type,
            data,
            error(responseData) {
                // console.log({ responseData, stat: responseData.status });
                // есть, к примеру, 400 ошибка, ответ с бека в которой нужно также обработать
                const response = responseData.responseJSON;
                const commonErrText = `Ошибка при обращении к ${this.url}`;
                const error = new Error();
                error.response = response;

                if (response?.status === 'error' || responseData.status !== 200) {
                    // console.log('reject...');
                    error.message = response?.message || commonErrText;

                    reject(error);
                    return;
                }

                reject(new Error(commonErrText));
            },
            success(responseData, textStatus, xhr) {
                resolve({ data: responseData, textStatus, xhr });
            },
            ...params,
        });
    });
}

export function post(url, params = {}) {
    return ajaxRequest(url, {
        type: 'post',
        ...params,
    });
}

export function get(url, params = {}) {
    return ajaxRequest(url, {
        type: 'get',
        ...params,
    });
}

export function addLoader(element = document.body) {
    try {
        element.classList.add('loader');
    } catch (e) {
        console.log(e.message);
    }
}

export function removeLoader(element = document.body) {
    try {
        element.classList.remove('loader');
    } catch (e) {
        console.log(e.message);
    }
}
